import './radio-button.css';

import classNames from 'classnames';
import React from 'react';

interface RadioProps {
  name?: string;
  value?: string;
  disabled?: boolean;
  checked?: boolean;
  label?: string;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  containerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  className?: string;
  color?: string;
  innerClassName?: string;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
}

export const Radio = ({
  name,
  value,
  disabled,
  checked,
  inputProps,
  containerProps,
  labelProps,
  label,
  color,
  className,
  innerClassName,
  onChange,
}: RadioProps) => {
  const wrapperClasses = classNames({
    radio: true,
    'radio-red': color === 'red',
    'radio-green': color === 'green',
    [className || '']: !!className,
  });
  const innerClasses = classNames({
    'radio-label inline-flex items-center align-middle': true,
    [innerClassName || '']: !!innerClassName,
  });
  return (
    <span {...containerProps} className={wrapperClasses}>
      <input
        id={value}
        name={name}
        type="radio"
        aria-label={label || 'radio button'}
        disabled={disabled}
        {...inputProps}
        checked={checked}
        onChange={onChange}
        value={value}
      />
      <label htmlFor={value} aria-label={label} {...labelProps} className={innerClasses}>
        <span>{label}</span>
      </label>
    </span>
  );
};
